import { Box } from '@chakra-ui/react';

import useGetRequestApprovalById from 'Domain/reschedule/useGetRequestApprovalById';
import Head from './section/head';
import Form from './section/form';

import styles from './styles.module.css';

const RescheduleDetail = () => {
  const { data: rescheduleDetail, isLoading } = useGetRequestApprovalById();

  return (
    <Box className={styles['reschedule-detail__container']}>
      <Head status={rescheduleDetail?.statusProgress} hostRequester={rescheduleDetail?.hostRequester} />
      <Form rescheduleDetail={rescheduleDetail} isLoading={isLoading} />
    </Box>
  );
};

export default RescheduleDetail;
